import NavHeader from './components/layout/NavHeader';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import CountdownStory from './components/sections/CountdownStory';
import DetailsAndDressCode from './components/sections/DetailsAndDressCode';
import Confirmations from './components/sections/Confirmations';
import TimeCapsule from './components/sections/TimeCapsule';

export default function App() {
  return (
    <div className="min-h-screen bg-brand-paper text-brand-ink">
      <NavHeader />
      <main id="home">
        <Hero />
        <CountdownStory />
        <DetailsAndDressCode />
        <Confirmations />
        <TimeCapsule />
      </main>
      <Footer />
    </div>
  );
}
